/* Kraymer Art redesign, storefront behaviour (Shopify theme, 25 Sep 2026).
   Drawers and sheets, the loot bag on the real Shopify cart (/cart.js), quick add, product form (variants, engraving,
   subscriptions), wishlist (this browser, shareable), predictive search, collection filters and sort (character grouping
   by default), carousels, customer videos, hero video, delivery country. No dependencies. */
(function () {
  'use strict';
  var K = window.KR || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT = (K.routes && K.routes.root) || '/';
  var url = function (p) { return (ROOT === '/' ? '' : ROOT.replace(/\/$/, '')) + p; };

  /* ---------------------------------------------------------------- money */
  function fmt(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var f = format || K.moneyFormat || '${{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var n = Number(cents) || 0;
    function withD(num, prec, th, dec) {
      th = th || ','; dec = dec || '.';
      var fixed = (num / 100).toFixed(prec);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = withD(n, 0); break;
      case 'amount_with_comma_separator': v = withD(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = withD(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = withD(n, 2, "'", '.'); break;
      default: v = withD(n, 2);
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }
  K.fmt = fmt;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  function img(src, w) {
    if (!src) return '';
    var u = src.replace(/^http:/, 'https:');
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }

  /* ---------------------------------------------------------------- toast */
  function toast(html, ms) {
    var el = $('.toast'); if (!el) return;
    el.innerHTML = html; el.classList.add('on');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('on'); }, ms || 1800);
  }
  K.toast = toast;

  /* ---------------------------------------------------------------- drawers and sheets */
  var scrim = $('.scrim'), lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    closeAll(true);
    lastFocus = document.activeElement;
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('kr-drawer-open');
    var f = el.querySelector('input[type=search],input:not([type=hidden]),button,a[href]');
    setTimeout(function () { try { (el.id === 'search' ? $('#kr-q') : f).focus({ preventScroll: true }); } catch (e) {} }, 60);
    el.dispatchEvent(new CustomEvent('kr:open', { bubbles: true }));
  }
  function closeAll(keepFocus) {
    $$('.drawer.on,.sheet.on').forEach(function (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); });
    if (scrim) scrim.classList.remove('on');
    document.documentElement.style.overflow = '';
    document.body.classList.remove('kr-drawer-open');
    if (!keepFocus && lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  K.open = function (id) { openPanel(document.getElementById(id)); };
  K.close = closeAll;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open]');
    if (t) {
      var target = document.getElementById(t.getAttribute('data-open'));
      if (target) { e.preventDefault(); openPanel(target); }
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
    if (e.key === 'Tab') {
      var open = $('.drawer.on,.sheet.on'); if (!open) return;
      var f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', open).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------------------------------------------------------------- cart */
  var cart = null;
  try { cart = JSON.parse(($('#kr-cart-json') || {}).textContent || 'null'); } catch (e) { cart = null; }
  var busy = 0, own = 0;
  var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';
  var T = K.tiers || { ship: 5000, tier: 15000, gift: 25000 };
  /* Solid Gold Edition (round 110, 12 Oct 2026): outside the sitewide discounts (tag no-sitewide-discount), so they never
     count toward the 20% step, and their cards open the product page (ring sizes are required, the engraving is part of it) */
  var FINE = ['solid-gold-malevolent-shrine-ring', 'solid-gold-pure-love-couple-ring-set', 'solid-gold-forest-spirit-earrings', 'solid-gold-flins-necklace', 'solid-gold-arlecchino-necklace'];
  /* Free Gold Collector box, claimed with one tap in the bag (David, 8 Oct 2026). The settings come from the header section
     (#kr-gold). The box goes in on its monthly plan with the code that makes the first one free; it is never added for the
     shopper, and it leaves the bag again if the bag drops under the 20% step or the code does not make it free. */
  var G = null; try { G = JSON.parse(($('#kr-gold') || {}).textContent || 'null'); } catch (e) { G = null; }
  (function () {   // unpublished themes only: ?krgold=tile|row|link|off picks the look for a preview
    var role = window.Shopify && Shopify.theme && Shopify.theme.role, m = /[?&]krgold=(\w+)/.exec(location.search), v = m && m[1];
    if (!G || !role || role === 'main') return;
    try { if (v) sessionStorage.setItem('krgold', v); v = sessionStorage.getItem('krgold'); } catch (e) {}
    if (v) { G.on = v !== 'off'; if (/^(tile|row|link)$/.test(v)) G.style = v; }
  })();
  var goldInfoOpen = false;   // the tile's i button: what is in the box (kept across bag redraws)
  /* Halloween Edition gift steps (David, 9 Oct 2026: the bag's steps did not show the edition's offer). Settings come from
     the header section (#kr-he). A Royal Black variant is an edition piece: the 32 edition listings are the only ones with one. */
  var H = null; try { H = JSON.parse(($('#kr-he') || {}).textContent || 'null'); } catch (e) { H = null; }
  function isEdition(it) { var m = String((H && H.mark) || '').toLowerCase(); return !!m && !isGiftLine(it) && String(it.variant_title || '').toLowerCase().indexOf(m) > -1; }
  function hasCharm(it) { var p = String((H && H.prop) || '').toLowerCase(), g = it.properties ? String(it.properties['Free gift'] || '').toLowerCase() : ''; return !!p && !!g && (g.indexOf(p) > -1 || g.indexOf('halloween charm') > -1); }   // 14 Oct 2026: lines written before the charm was named say "Halloween charm"
  /* The charm comes with four pieces (David, 9 Oct 2026: the step should fill as pieces go in, "if they have two pieces ... it
     can be half full already", and count "jewellery or charms"). Counted: necklaces, rings, bracelets, earrings and charms;
     a full set is four, the five-piece set five, any other set two, the charm set three. Not pins, boxes, free lines or anything on a plan. */
  function heNeed() { return Number(H && H.need) || 4; }
  function hePieces(c) {
    return ((c || {}).items || []).reduce(function (a, it) {
      if (it.selling_plan_allocation || isGiftLine(it) || !it.final_line_price) return a;
      var t = (it.product_type || '').toLowerCase(), n = 0;
      if (/^(necklace|ring|bracelet|earrings|charm)$/.test(t)) n = 1;
      else if (t === 'charm set') n = 3;
      else if (t === 'jewelry sets') n = /^full\b/i.test(it.product_title || '') ? 4 : /^five/i.test(it.product_title || '') ? 5 : 2;
      return a + n * it.quantity;
    }, 0);
  }
  /* Founders Edition bag bar (David, 26 Oct 2026: "ok fix it then"). A bag holding any Wizard Houses, Four Nations or Apothecary
     launch piece (K.launch.o, the kl_open list in snippets/kr-launch-pct: the pieces of the offer collection 492182864034) shows the
     Founders steps instead of the Halloween ones, whatever page the shopper came from: free shipping, 2 pieces 30% off, 4 pieces
     40% off and the free Founders Edition charm. Counted like the checkout counts: the 30% and 40% discounts count every unit of
     those pieces (a full collection or a couple ring set is one, enamel pins never); a full collection is always 40%; the charm
     is AOV.ai's, 4 or more units from its FREESEALCHARM list or any full collection on its FREESEALCHARMSET list, read live from
     the campaigns (#kr-fe, snippets/kr-cart-drawer) with their dates. The club month moves to one line under the steps. */
  var FE; function feCfg() { if (FE === undefined) { try { FE = JSON.parse(($('#kr-fe') || {}).textContent || 'null'); } catch (e) { FE = null; } } return FE; }
  function feLive(c) { var t = Date.now(); return !!(c && c.on && c.h && c.h.length && !(c.s && t < c.s) && !(c.e && t >= c.e)); }
  function feState(items) {
    var L = K.launch; if (!L || !L.o || Date.now() < L.os) return null;
    var C = feCfg() || {}, P = feLive(C.p) ? C.p : null, S = feLive(C.set) ? C.set : null;
    var r = { n: 0, c: 0, set: false, full: false, top: 0, P: P, S: S };
    /* 4 Nov 2026: the 18K seal charm (Fairy-Tale Princess, AOV.ai, 4+ of its pieces or one of its full collections) is its own
       program: L.sl lists its pieces (2 = a full collection), L.se its end, L.sq the pieces it needs. A bag holding more seal pieces
       than pieces on the matching charm list follows the seal program and its end date (after the end, no charm line at all). */
    var SL = L.sl || {}, sOn = !!(L.se && Date.now() < L.se), m2 = 0, c2 = 0, set2 = false;
    items.forEach(function (it) {
      if (it.selling_plan_allocation || it.gift_card || isGiftLine(it) || !(it.original_line_price > 0)) return;
      if (/pin/i.test(it.product_type || '') || /enamel pin/i.test(it.product_title || '')) return;   // pins are never in the offer
      var h = it.handle, p = h && Number(L.o[h]); if (!p) return;
      r.n += it.quantity; r.top = Math.max(r.top, p); if (p >= 40) r.full = true;   // a full collection is always 40%
      if (P && P.h.indexOf(h) > -1) r.c += it.quantity;
      if (S && S.h.indexOf(h) > -1) r.set = true;
      if (SL[h]) { m2 += it.quantity; c2 += it.quantity; if (Number(SL[h]) === 2) set2 = true; }
    });
    if (m2 > r.c) {
      r.P = sOn ? { q: Number(L.sq) || 4, h: [] } : null; r.S = sOn ? { h: [] } : null;
      r.c = c2; r.set = sOn && set2; r.lab = ' a free 18K seal charm';
    }
    return r.n ? r : null;
  }
  function feMore(k) { return k + ' more ' + (k === 1 ? 'piece' : 'pieces'); }
  function feView(f, view) {
    var n = f.n, need = 4, charmOn = !!(f.P || f.S), cq = f.P ? Number(f.P.q) || 4 : 0;
    var charm = f.set || (!!f.P && f.c >= cq), shipOk = !!(view.ship && view.ship.ok);
    var ct = charmOn ? '40% off +' + (f.lab || ' a free matching charm') : '40% off';
    var paint = [view.ship,
      { k: '2 pieces', t: '30% off', f: f.full ? 1 : Math.min(1, n / 2), ok: f.full || n >= 2 },
      f.full && n < need ? { k: 'Full collection', t: f.set ? ct : '40% off', f: 1, ok: true }
        : { k: '4 pieces', t: ct, f: Math.max(0, Math.min(1, (n - 2) / 2)), ok: n >= need && (charm || !f.P) }];
    var ends = '', freeC = f.lab || ' a free matching charm';
    var kc = charm || !f.P ? 0 : cq - f.c, k4 = Math.max(0, need - n), msg, done = false;
    var withC = function (k) { return !kc ? (charmOn ? ' and' + freeC : '') : kc <= k ? ' and' + freeC : ', and ' + feMore(kc) + ' for' + freeC; };
    if (f.full && n >= need) { done = !kc; msg = 'You&#8217;ve unlocked ' + (shipOk ? 'free shipping, ' : '') + '40% off every piece' + (charm ? ' and' + freeC + '!' : kc ? '. Add ' + feMore(kc) + ' for' + freeC + '.' : '!') + ends; }
    else if (f.full) msg = 'Your full collection is 40% off' + (f.set ? ' with' + freeC : '') + '. Add ' + feMore(k4) + ' for 40% off those too' + (kc && !f.set ? ', and ' + feMore(kc) + ' for' + freeC : '') + '.' + ends;
    else if (n >= need && !kc) { done = true; msg = 'You&#8217;ve unlocked ' + (shipOk ? 'free shipping, ' : '') + '40% off' + (charmOn ? ' and' + freeC : '') + '!' + ends; }
    else if (n >= need) msg = (shipOk ? 'Free shipping and ' : '') + '40% off unlocked. Add ' + feMore(kc) + ' for' + freeC + '.' + ends;
    else if (n >= 2 || f.top >= 30) msg = (shipOk ? 'Free shipping and ' : '') + '30% off unlocked. Add ' + feMore(k4) + ' for 40% off' + withC(k4) + '.' + ends;
    else msg = (shipOk ? 'Free shipping and ' : '') + '20% off unlocked. Add 1 more piece for 30% off, or 3 more for 40% off' + withC(3) + '.' + ends;
    msg = msg.charAt(0).toUpperCase() + msg.slice(1);
    return { paint: paint, msg: msg, done: done, shipOk: shipOk };
  }
  function goldOn() { return !!(G && G.on && G.variant && G.plan && G.code); }
  function goldLine(c) { return goldOn() ? ((c || {}).items || []).filter(function (it) { return String(it.variant_id) === String(G.variant) && it.properties && it.properties._kr_gift === 'gold-box'; })[0] : null; }
  function goldNote() { return String(G.note || '').replace('[price]', G.monthly || ''); }
  function goldMin() { return (G && G.min) || T.gift; }
  // What counts toward the box: what the bag charges for its one-off pieces (after the 20%). Not the box, not subscriptions.
  function goldSpend(c) { return ((c || {}).items || []).reduce(function (a, it) { return it.selling_plan_allocation || it.gift_card || isGiftLine(it) ? a : a + (it.final_line_price || 0); }, 0); }
  function goldWas() { return G.value && (!K.currency || K.currency === 'USD') ? '<s>' + esc(G.value) + '</s>' : ''; }

  function jfetch(u, opt) {
    opt = opt || {};
    opt.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opt.headers || {});
    opt.credentials = 'same-origin';
    own++;
    return fetch(u, opt).then(function (r) {
      own--;
      // parse defensively: a rate-limit or error page comes back as HTML, not JSON
      return r.text().then(function (t) {
        var j = null; try { j = JSON.parse(t); } catch (e) { j = null; }
        if (!r.ok || !j) { var er = new Error((j && (j.description || j.message)) || (r.status === 429 ? 'The store is busy for a moment. Please try again.' : 'Something went wrong. Please try again.')); er.data = j || {}; throw er; }
        return j;
      });
    }, function (err) { own--; throw err; });
  }
  var cartLive = false;   // true once the bag has been read from /cart.js (the bag printed with the page has no discount_codes)
  function getCart() { return jfetch(url('/cart.js'), { method: 'GET' }).then(function (c) { cart = c; cartLive = true; renderCart(); return c; }); }
  K.refreshCart = getCart;

  function charmCount(it) { var t = (it.product_type || '').toLowerCase(); return t === 'charm' ? 1 : t === 'charm set' ? 3 : 0; }
  function isGiftLine(it) { return it.properties && (it.properties._kr_gift || it.properties['_kr_gift']); }
  /* Products outside the sitewide discounts (tag no-sitewide-discount: the watches, Founders Edition pieces, solid gold) never count toward
     the 20% step, so a bag holding only those never says the 20% is earned (28 Oct 2026). Seeded from snippets/kr-cart-drawer
     (#kr-nosite), completed by cmpLoad's product read. */
  var NOSITE = {}; try { (JSON.parse(($('#kr-nosite') || {}).textContent || '[]') || []).forEach(function (h) { if (h) NOSITE[h] = 1; }); } catch (e) {}
  function eligibleSubtotal(c) {
    /* List-price subtotal of the lines the 20% tier counts: every one-off, paid line. The 20% discount covers jewelry, sets,
       charms and pins; a line's own discount allocations can't be used to tell, because charms carry none until the cart
       reaches the tier (they sit outside the storewide 15%). That hid the 20% step for charm carts (David, 25 Sep). */
    return (c.items || []).reduce(function (a, it) {
      if (it.selling_plan_allocation || it.gift_card || !it.original_line_price || it.final_line_price === 0) return a;   // a gift card is never discounted (round 107)
      if (FINE.indexOf(it.handle) > -1 || NOSITE[it.handle]) return a;   // solid gold pieces (round 110) and every no-sitewide-discount piece are never discounted
      return a + it.original_line_price;
    }, 0);
  }

  /* Founders saving in the bag (David, 25 Oct 2026): a piece kept out of the 15%/20% tiers (tag no-sitewide-discount) that carries a
     compare-at price shows that price struck through beside what it costs, in the shopper's currency, and the difference counts in
     Total savings. /cart.js has no compare-at, so it is read once per product from /products/<handle>.js (prices in the shopper's
     currency). Lines the tiers already discount keep their own strikethrough. */
  var CMP = {}, CMPP = {}, cmpAsked = {};
  function cmpPlain(it) { return !it.selling_plan_allocation && !it.gift_card && !isGiftLine(it) && it.final_line_price > 0 && it.final_line_price === it.original_line_price; }
  /* A line priced by a running Intelligems test (original_price differs from the variant's own price) gets its compare-at scaled by the
     same ratio, which is what Intelligems shows on the product page (28 Oct 2026: PT-02 B, watch $297 -> $267.30, compare $500 -> $450). */
  function cmpOf(it) {
    var c = CMP[it.variant_id], p = CMPP[it.variant_id];
    if (c && p && it.original_price !== p) c = Math.round(c * it.original_price / p);
    return c && cmpPlain(it) && c > it.original_price ? c : 0;
  }
  function cmpLoad(items) {
    var need = [];
    items.forEach(function (it) { if (it.handle && !cmpAsked[it.handle] && cmpPlain(it)) { cmpAsked[it.handle] = 1; need.push(it.handle); } });
    if (!need.length) return;
    Promise.all(need.map(function (h) {
      return jfetch(url('/products/' + h + '.js'), { method: 'GET' }).then(function (p) {
        if (!p || (p.tags || []).indexOf('no-sitewide-discount') < 0) return 0;
        var n = NOSITE[h] ? 0 : 1; NOSITE[h] = 1;   // newly learned: redraw so the 20% step stops counting it
        (p.variants || []).forEach(function (v) { if (v.compare_at_price && v.compare_at_price > v.price) { CMP[v.id] = v.compare_at_price; CMPP[v.id] = v.price; n++; } });
        return n;
      }, function () { delete cmpAsked[h]; return 0; });
    })).then(function (r) { if (r.some(Boolean)) renderCart(); });
  }

  function renderCart() {
    var list = $('#cart-items'); if (!list || !cart) return;
    var items = cart.items || [], count = cart.item_count || 0;
    cmpLoad(items);
    $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.classList.toggle('on', count > 0); });
    $$('[data-cart-count2]').forEach(function (b) { b.textContent = count || ''; });
    var sub = eligibleSubtotal(cart), paid = cart.items_subtotal_price;
    var html = '';
    var gold = goldLine(cart);
    var heS = heState(cart);   // the free charm line shows the moment the bag holds four pieces, and goes the moment it does not
    items.forEach(function (it) {
      if (gold && it.key === gold.key) return;   // the box shows in the gift block at the top of the bag, not down the list
      var gift = isGiftLine(it) || (it.final_line_price === 0 && it.original_line_price > 0);
      var props = '';
      if (it.properties) Object.keys(it.properties).forEach(function (k) { var v = it.properties[k]; if (k.charAt(0) !== '_' && v && !(k === 'Free gift' && heS.auto && heS.auto.key === it.key && !heS.due)) props += '<div class="props">' + esc(k) + ': ' + esc(v) + '</div>'; });
      if (heS.due && !heS.auto && heS.ed.key === it.key) props += '<div class="props">Free gift: ' + esc(H.prop) + '</div>';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="v">' + esc(it.variant_title) + '</div>' : '';
      var plan = it.selling_plan_allocation ? '<div class="v">' + esc(it.selling_plan_allocation.selling_plan.name) + '</div>' : '';
      var discs = (it.line_level_discount_allocations || []).map(function (d) { return d.discount_application && d.discount_application.title; }).filter(Boolean);
      var was = cmpOf(it) * it.quantity;
      var price = it.final_line_price < it.original_line_price
        ? '<s>' + fmt(it.original_line_price) + '</s><b>' + (it.final_line_price === 0 ? 'Free' : fmt(it.final_line_price)) + '</b>'
        : was ? '<s>' + fmt(was) + '</s><b>' + fmt(it.final_line_price) + '</b>'
        : '<b>' + fmt(it.final_line_price) + '</b>';
      var im = it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="ph" style="width:64px;height:64px"></span>';
      html += '<div class="citem' + (gift ? ' gift' : '') + '" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '">' + im + '</a><div class="ci"><a class="t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + plan + props +
        (discs.length && !gift ? '<div class="disc">' + esc(discs[discs.length - 1]) + ' applied</div>' : '') +
        (gift ? '' : '<div class="qty"><button type="button" data-q="' + esc(it.key) + '" data-d="-1" aria-label="One less">&minus;</button><span>' + it.quantity + '</span><button type="button" data-q="' + esc(it.key) + '" data-d="1" aria-label="One more">+</button></div>') +
        '</div><div class="pr">' + price + '</div></div>';
    });
    var gSpend = goldSpend(cart);
    /* The free gift block is the first thing in the bag (David, 9 Oct 2026: under the pieces it "gets hidden" once there are
       a few of them). It shows Claim once the box is unlocked, and the box itself once claimed. goldPend: the tap has been
       made and the bag requests are still on their way, so the box already shows as added. */
    var goldHave = !!gold || goldPend;
    var goldOpen = goldOn() && !goldHave && items.length > 0 && gSpend >= goldMin();
    var goldTile = '';
    if (goldOn() && items.length > 0 && (goldOpen || goldHave)) {
      var gFree = !gold || goldPend || gold.final_line_price === 0;
      goldTile = '<div class="cgold ' + (G.style === 'row' ? 'row' : 'tile') + (goldHave ? ' in' : '') + '">' + (G.style === 'row' ? '' : '<div class="cg-h"><span>Your free gift</span><span>' + (goldHave ? '1' : '0') + ' of 1 added</span></div>') +
        '<div class="cg-b"><img src="' + esc(G.img) + '" alt="" width="56" height="56"><div class="cg-t"><b>' + esc(G.title) + (G.info ? '<button type="button" class="cg-i" data-gold-info aria-expanded="' + (goldInfoOpen ? 'true' : 'false') + '" aria-label="About the ' + esc(G.title) + '">i</button>' : '') + '</b>' +
        (G.sub ? '<span>' + esc(G.sub) + '</span>' : '') + '<span class="cg-p">' + (gFree ? (goldWas() || (gold ? '<s>' + fmt(gold.original_line_price) + '</s>' : '')) + '<i>Free</i>' : '<i>' + fmt(gold.final_line_price) + '</i>') + '</span></div>' +
        (goldHave ? '<span class="cg-ok">' + CHECK + 'Added</span>' : '<button type="button" class="cg-add" data-gold-claim>' + esc(G.button || 'Claim') + '</button>') + '</div>' +
        (G.info ? '<p class="cg-info"' + (goldInfoOpen ? '' : ' hidden') + '>' + esc(G.info) + '</p>' : '') +
        '<p class="cg-n">' + esc(goldNote()) + (gold ? ' <button type="button" class="rm" data-q="' + esc(gold.key) + '" data-d="-1">Remove</button>' : '') + '</p></div>';
    }
    var goldTop = G && (G.style !== 'link' || goldHave) ? goldTile : '';
    var pageGold = $('#kp-gold'); if (pageGold) pageGold.innerHTML = gold ? '' : goldTile;   // the /cart page prints a claimed box as one of its own lines
    list.innerHTML = items.length ? goldTop + html : '<div class="cempty"><div class="cttl">Your loot bag is empty</div>Find the piece that belongs to your world.<div style="margin-top:18px"><a class="btn" href="' + url('/collections/jewelry') + '">Shop best sellers</a></div></div>';
    if (goldTop && !goldShown) list.scrollTop = 0;   // the gift has just appeared: bring it into view
    goldShown = !!goldTop;
    if (adding > 0) addingRow();
    // reward bars: each fills from the previous threshold to its own.
    // Labels and "away" amounts round up to a whole unit (A$72, not A$71.34); the unlock checks use the exact thresholds.
    // The 20% step hides only when nothing in the bag counts (subscriptions, free gifts).
    var up = function (c) { return Math.ceil(c / 100) * 100; };
    var noTier = items.length > 0 && sub === 0;
    var gOn = goldOn(), gName = gOn ? 'a free ' + G.title : '', pct = (K.tierPct || 20) + '% off';
    var steps = [['ship', T.ship, paid, 'free shipping', 'Free shipping'], ['tier', T.tier, sub, pct, pct], gOn ? ['gift', goldMin(), gSpend, gold ? 'your free ' + G.title : gName, G.step || 'Gold box'] : ['gift', T.gift, paid, 'a mystery gift', 'Mystery gift']]
      .filter(function (s) { return !(noTier && s[0] === 'tier'); });
    // the box has the third step to itself (David, 9 Oct 2026: "set it as $200 usd instead")
    var prev = 0, got = [], next = null, tierOk = false, view = {};
    steps.forEach(function (s) {
      var f = Math.max(0, Math.min(1, (s[2] - prev) / Math.max(1, s[1] - prev)));
      var ok = items.length > 0 && s[2] >= s[1];
      var need = s[1] - s[2];
      // the box step counts what the bag charges, so once the 20% is on, the gap is bigger in shelf prices
      if (gOn && s[0] === 'gift' && tierOk && sub > 0 && gSpend > 0 && gSpend < sub) need = need * sub / gSpend;
      if (ok) got.push(s[3]); else if (!next) next = { away: up(need), label: s[3], jewelry: false, step: s[0] };
      if (s[0] === 'tier') tierOk = ok;
      view[s[0]] = { k: fmt(up(s[1]), K.moneyFormat).replace(/\.00$/, '') + '+', t: s[4], f: items.length ? f : 0, ok: ok };
      prev = s[1];
    });
    /* Halloween Edition (David, 9 Oct 2026): a bag with a Royal Black piece that has earned free shipping and the 20% shows
       free shipping, the Gold Collector box and the pieces counted toward the charm (four pieces, a quarter of the bar each).
       Any other bag keeps free shipping, 20% off and the box. */
    var fe = feState(items), feV = fe ? feView(fe, view) : null;   // Founders Edition bag bar (see feState)
    var heMode = !feV && !!(H && H.on && gOn && view.ship && view.ship.ok && view.tier && view.tier.ok && items.some(isEdition));
    var need = heNeed(), pcs = !heMode ? 0 : heS.fromSet ? need : Math.min(need, hePieces(cart)), charm = heMode && pcs >= need;
    var paint = feV ? feV.paint : heMode ? [view.ship, view.gift, { k: String(H.k3 || '[n] of [need] pieces').replace('[n]', pcs).replace('[need]', need), t: H.t3, f: pcs / need, ok: charm }] : [view.ship, view.tier, view.gift];
    var segs = $('#ladder-segs'); if (segs) { segs.classList.toggle('two', !feV && !heMode && noTier); segs.classList.toggle('he', heMode || !!feV); }
    ['ship', 'tier', 'gift'].forEach(function (id, n) {
      var d = $('[data-seg="' + id + '"]'), p = paint[n]; if (!d) return;
      d.classList.toggle('hidden', !p); if (!p) return;
      var lab = $('span', d); if (lab) lab.innerHTML = '<em data-t="' + id + '">' + esc(p.k) + '</em>' + esc(p.t);
      $('b', d).style.width = (p.f * 100) + '%';
      d.classList.toggle('got', p.ok);
    });
    var msg = $('#ladder-msg');
    var join = function (a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; };
    var awayTxt = next && (next.jewelry ? 'Add <b>' + fmt(next.away).replace(/\.00$/, '') + '</b> more in jewelry for <b>' + next.label + '</b>.'
      : '<b>' + fmt(next.away).replace(/\.00$/, '') + '</b> away from <b>' + next.label + '</b>.');
    if (msg) msg.innerHTML = !items.length ? 'Add a piece to start unlocking rewards.'
      : feV ? (feV.done || feV.shipOk ? CHECK + '<span>' + feV.msg + '</span>' : '<span>' + feV.msg + (next && next.step === 'ship' ? ' ' + awayTxt : '') + '</span>')
      : heMode && !next ? CHECK + '<span>' + esc(charm ? H.all : String(H.next || '').replace('[more]', (need - pcs) + ' more ' + (need - pcs === 1 ? 'piece' : 'pieces'))) + '</span>'
      : !next ? CHECK + '<span>You&#8217;ve earned ' + join(got) + '!</span>'
      : got.length ? CHECK + '<span>' + join(got).replace(/^./, function (c) { return c.toUpperCase(); }) + ' unlocked. ' + awayTxt + '</span>'
      : '<span>' + (next.jewelry ? awayTxt : 'You&#8217;re ' + awayTxt) + '</span>';
    /* Founders bags: the club month is one line under the steps, on its own spend line (the third step in every other bag) */
    var club = $('#ladder-club');
    if (club) {
      var cl = !!feV && gOn && items.length > 0 && view.gift;
      club.classList.toggle('hidden', !cl);
      if (cl) {
        var cNeed = goldMin() - gSpend; if (sub > 0 && gSpend > 0 && gSpend < sub) cNeed = cNeed * sub / gSpend;
        club.innerHTML = view.gift.ok ? CHECK + '<span>Free ' + esc(G.title || 'Collector Club month') + ' unlocked.</span>'
          : '<span>Free ' + esc(G.title || 'Collector Club month') + ' at <b>' + esc(view.gift.k) + '</b>. <b>' + fmt(up(cNeed)).replace(/\.00$/, '') + '</b> away.</span>';
      }
    }
    if (msg && goldOpen && G.style === 'link') msg.innerHTML = CHECK + '<span>You&#8217;ve unlocked ' + esc(gName) + '. <button type="button" class="glink" data-gold-claim>Claim it</button><small>' + esc(goldNote()) + '</small></span>';
    var save = (cart.original_total_price || 0) - (cart.total_price || 0);
    if (gold) save -= (gold.original_line_price - gold.final_line_price);
    items.forEach(function (it) { var c = cmpOf(it); if (c) save += (c - it.original_price) * it.quantity; });   // Founders saving (see cmpLoad)
    /* "Total savings" is money off only; a free gift's value is not counted (audit, 25 Sep) */
    var discRow = $('#cart-disc-row');
    if (discRow) {
      discRow.classList.toggle('hidden', !(save > 0));
      $('#cart-disc').textContent = '−' + fmt(save);
    }
    var sv = $('#cart-save'); if (sv) { sv.textContent = save > 0 ? 'Save ' + fmt(save) : ''; sv.classList.toggle('hidden', !(save > 0)); }
    var tot = $('#cart-total'); if (tot) tot.textContent = fmt(cart.total_price) + (K.currency ? ' ' + K.currency : '');
    var foot = $('#cart-foot'); if (foot) foot.classList.toggle('hidden', !items.length);
    /* The bag's own ladder, for the add-on row (assets/kr-bag-addons.js, 1 Nov 2026): it says a card "Unlocks ..." only from
       these numbers, never from a copy of them. steps: each money step with its line (at) and what counts toward it (have). */
    K.ladder = { n: items.length, paid: paid, sub: sub, spend: gSpend, tierOk: tierOk, noTier: noTier,
      steps: steps.map(function (s) { return { id: s[0], at: s[1], have: s[2], label: s[3], ok: items.length > 0 && s[2] >= s[1] }; }),
      he: heMode ? { pcs: pcs, need: need, t: H.t3 || '' } : null, fe: feV ? { n: fe.n, full: fe.full, top: fe.top, charm: !!(fe.P || fe.S) } : null,
      nosite: NOSITE };
    document.dispatchEvent(new CustomEvent('kr:cart', { detail: cart }));
  }

  function setBusy(on) { var c = $('#cart'); busy += on ? 1 : -1; if (c) c.classList.toggle('busy', busy > 0); }
  function cartError(err) {
    var msg = (err && err.data && (err.data.description || err.data.message)) || (err && err.message) || 'Something went wrong. Please try again.';
    toast(esc(msg), 3200);
  }
  /* The add takes the store one to two seconds (measured 9 Oct 2026: 1.7 to 2.1 s from the tap to the bag). The bag opens
     on the tap with a placeholder row where the piece will land, so the wait is not a dead button (David, 9 Oct 2026:
     "make sure everything works well and isn't too slow"). */
  var adding = 0;
  function addingRow() {
    var l = $('#cart-items'); if (!l || $('.csk', l)) return;
    if ($('.cempty', l)) l.innerHTML = '';
    var d = document.createElement('div'), g = $('.cgold', l); d.className = 'csk'; d.setAttribute('aria-hidden', 'true'); d.innerHTML = '<span></span><div><i></i><i></i></div>';
    l.insertBefore(d, g ? g.nextSibling : l.firstChild);
  }
  function addItems(items, opts) {
    opts = opts || {};
    var box = $('#cart'), show = opts.open !== false && !!box && !!$('#cart-items'), ph = show;
    setBusy(true);
    if (show) { adding++; box.classList.add('adding'); addingRow(); if (!box.classList.contains('on')) K.open('cart'); if (!opts.stay) $('#cart-items').scrollTop = 0; }   // stay: an add from inside the bag (the add-on row) keeps the shopper's place
    var un = function () { if (!ph) return; ph = false; adding = Math.max(0, adding - 1); if (!adding) { box.classList.remove('adding'); $$('.csk', box).forEach(function (e) { e.remove(); }); } };
    return jfetch(url('/cart/add.js'), { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(function () { return jfetch(url('/cart.js'), { method: 'GET' }); })
      .then(function (c) { un(); cart = c; cartLive = true; renderCart(); return syncCharmGift(c); })
      .then(function (c) { return syncGold(c || cart); })
      .then(function (c) { setBusy(false); if (opts.open !== false && !show) K.open('cart'); syncHe(c || cart); later(); })
      .catch(function (err) { un(); setBusy(false); renderCart(); cartError(err); throw err; });
  }
  K.add = addItems;
  function changeLine(key, qty) {
    setBusy(true);
    return jfetch(url('/cart/change.js'), { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (c) { cart = c; renderCart(); return syncCharmGift(c); })
      .then(function (c) { return syncGold(c || cart); })
      .then(function (c) { setBusy(false); syncHe(c || cart); later(); })
      .catch(function (err) { setBusy(false); cartError(err); getCart().catch(function () {}); });
  }
  // apps (the AOV mystery gift) add lines a moment after ours: look again shortly after every change
  var laterT;
  function later() { clearTimeout(laterT); laterT = setTimeout(function () { getCart().then(syncCharmGift).then(function (c) { return syncGold(c || cart); }).then(function (c) { return syncHe(c || cart); }).catch(function () {}); }, 1400); }
  /* Halloween charm with any four pieces: the piece picker writes "Free gift" on a full Royal Black set. For four pieces picked
     one by one the bag writes the same line on the first Royal Black piece (so the order carries it), and takes it off again
     when the bag drops under four or a full set already carries it. */
  var heBusy = false, heAsk = 0;
  function heState(c) {
    var items = (c || {}).items || [], on = !!(H && H.on);
    var auto = on ? items.filter(function (it) { return it.properties && it.properties._kr_charm === 'auto'; })[0] : null;
    var fromSet = on && items.some(function (it) { return hasCharm(it) && !(it.properties && it.properties._kr_charm === 'auto'); });
    var ed = on ? items.filter(isEdition)[0] : null;
    return { auto: auto || null, fromSet: fromSet, ed: ed || null, due: !!ed && !fromSet && hePieces(c) >= heNeed() };
  }
  function heWait(on) { var c = $('#cart'); if (c) c.classList.toggle('hewait', !!on); }
  /* XMLHttpRequest on purpose. The free-gift app (AOV) wraps fetch and answers a /cart/change.js that carries properties with the
     bag as it stands, without sending it (seen 9 Oct 2026: 200, nothing changed; the same request sent plain works). */
  function xpost(u, body) {
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest(); x.open('POST', u); x._krU = '';
      x.setRequestHeader('Content-Type', 'application/json'); x.setRequestHeader('Accept', 'application/json'); x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.onload = function () { var j = null; try { j = JSON.parse(x.responseText); } catch (e) { j = null; } if (x.status >= 200 && x.status < 300 && j && j.items) res(j); else rej(new Error('bag')); };
      x.onerror = function () { rej(new Error('bag')); }; x.send(JSON.stringify(body));
    });
  }
  function syncHe(c) {
    if (!H || !H.on || !c || heBusy || goldPend || goldBusy) return Promise.resolve(c);
    var st = heState(c), auto = st.auto, ed = st.ed, due = st.due;
    if (due === !!auto) return Promise.resolve(c);
    var line = auto || ed, props = {};
    /* change.js replaces the whole set of properties, and an empty set changes nothing: so everything else on the line is sent
       back with it, and a line left with none keeps one hidden marker */
    Object.keys(line.properties || {}).forEach(function (k) { if (k !== 'Free gift' && k !== '_kr_charm') props[k] = line.properties[k]; });
    if (!auto) { props['Free gift'] = H.prop; props._kr_charm = 'auto'; } else if (!Object.keys(props).length) props._kr_charm = 'off';
    /* The bag already shows the line by the rule (renderCart), so nothing waits on this write: the quantity buttons rest for
       the moment it takes (the line's key changes) and a Checkout tap made meanwhile goes through when it lands. */
    heBusy = true; own++; heWait(true);
    var fin = function () { own--; heBusy = false; heWait(false); goldFlush(); };
    return xpost(url('/cart/change.js'), { id: line.key, quantity: line.quantity, properties: props })
      .then(function (x) { fin(); cart = x; goldDirty = true; renderCart(); return x; }, function () { fin(); return c; });
  }

  // Free charm bracelet with 3 charms (on only when a gift variant is set in Theme settings > Kraymer redesign)
  var charmBusy = false;
  function syncCharmGift(c) {
    var gv = K.charm && K.charm.variant; if (!gv || !c || charmBusy) return syncLaunchGift(c);
    var n = 0, gift = null;
    (c.items || []).forEach(function (it) { if (String(it.variant_id) === String(gv)) gift = it; else n += charmCount(it) * it.quantity; });
    var need = (K.charm && K.charm.need) || 3;
    if (n >= need && !gift) {
      charmBusy = true;
      return jfetch(url('/cart/add.js'), { method: 'POST', body: JSON.stringify({ items: [{ id: Number(gv), quantity: 1, properties: { _kr_gift: 'charm-bracelet' } }] }) })
        .then(getCart).then(function (x) { charmBusy = false; toast('Your free charm bracelet was added'); return x; }, function () { charmBusy = false; return c; });
    }
    if (n < need && gift) {
      charmBusy = true;
      return jfetch(url('/cart/change.js'), { method: 'POST', body: JSON.stringify({ id: gift.key, quantity: 0 }) })
        .then(function (x) { cart = x; renderCart(); charmBusy = false; return x; }, function () { charmBusy = false; return c; });
    }
    if (gift && gift.quantity > 1) {
      charmBusy = true;
      return jfetch(url('/cart/change.js'), { method: 'POST', body: JSON.stringify({ id: gift.key, quantity: 1 }) })
        .then(function (x) { cart = x; renderCart(); charmBusy = false; return x; }, function () { charmBusy = false; return c; });
    }
    return syncLaunchGift(c);
  }

  /* Founders Edition free charm (David, 25 Oct 2026: "these will be hte free gifts for 4pc or more"): Wizard Houses, Four
     Nations and Apothecary. The series charm goes in at US$0 when the bag holds 4 or more pieces of that series, or one of its
     full-collection listings, and leaves again when it does not. Each gift is a hidden US$0 product (Buy X Get Y never
     applied next to the 30% tier, carts 25 Oct), so this script is the only thing that puts it in the bag. Settings: snippets/kr-launch-gift.liquid (KR.lgift). Gift lines carry _kr_gift = launch-<series>. */
  var lgBusy = false, lgAsk = 0, lgPass = false;   // lgPass: the next Checkout submit is the held tap going through; never check it twice
  /* One series' state in the bag. A gift line is any line of the series' gift variant (that variant is only ever a gift, so a
     line put in without our marker, by a link or another form, counts too) or any line carrying our marker. */
  function lgState(s, items, need) {
    var tag = 'launch-' + s.k, n = 0, set = false, gifts = [];
    items.forEach(function (it) {
      if (String(it.variant_id) === String(s.gift) || (it.properties && it.properties._kr_gift === tag)) { gifts.push(it); return; }
      if (isGiftLine(it) || it.selling_plan_allocation || s.h.indexOf(it.handle) < 0) return;
      if (/pin/i.test(it.product_type || '') || /enamel pin/i.test(it.product_title || '')) return;   // an enamel pin never counts, even in a launch collection (David, 25 Oct 2026: "just liek dont count them")
      if (/full-collection/.test(it.handle)) set = true; else n += it.quantity;
    });
    var due = set || n >= need;
    return { tag: tag, due: due, gifts: gifts, ok: due ? gifts.length === 1 && gifts[0].quantity === 1 : !gifts.length };
  }
  function lgOwed(c) {   // true when some series' charm line is missing, left over, doubled or above quantity 1
    var LG = K.lgift; if (!LG || !LG.s || !c) return false;
    var items = c.items || [], need = LG.need || 4;
    return LG.s.some(function (s) { return s.gift && s.h && !lgState(s, items, need).ok; });
  }
  function syncLaunchGift(c, depth) {
    var LG = K.lgift; depth = depth || 0;
    if (!LG || !LG.s || !c || lgBusy || depth > 6) return Promise.resolve(c);
    var items = c.items || [], need = LG.need || 4;
    for (var i = 0; i < LG.s.length; i++) {
      var s = LG.s[i]; if (!s.gift || !s.h) continue;
      var st = lgState(s, items, need), act = null, added = false, g = st.gifts;
      if (st.ok) continue;
      if (st.due && !g.length) { added = true; act = jfetch(url('/cart/add.js'), { method: 'POST', body: JSON.stringify({ items: [{ id: Number(s.gift), quantity: 1, properties: { _kr_gift: st.tag } }] }) }).then(getCart); }
      else if (!st.due || g.length > 1) act = jfetch(url('/cart/change.js'), { method: 'POST', body: JSON.stringify({ id: g[g.length - 1].key, quantity: 0 }) });
      else act = jfetch(url('/cart/change.js'), { method: 'POST', body: JSON.stringify({ id: g[0].key, quantity: 1 }) });
      lgBusy = true;
      return act.then(function (x) { lgBusy = false; cart = x; renderCart(); if (added && s.t) toast('Your free ' + esc(s.t) + ' was added'); return syncLaunchGift(x, depth + 1); },
                      function () { lgBusy = false; return c; })
        .then(function (x) { if (!lgBusy && goldGo) { lgPass = true; goldFlush(); } return x; });   // a Checkout tap held while the charm went in goes through now
    }
    return Promise.resolve(c);
  }

  // Free Gold Collector box: the shopper taps Claim; the box goes in on its monthly plan and the code makes the first one free
  var goldBusy = false, goldTries = 0, goldDirty = false, goldPend = false, goldShown = false, goldGo = null;
  // the /cart page prints its lines on the server: after the box is claimed, fixed or taken out there, load the page again
  function goldPage(c) { if (goldDirty && $('#kp-gold') && !goldGo) { goldDirty = false; location.reload(); } return c; }
  /* A Checkout tap while the box is still going in waits for it, so nobody reaches checkout with the box at full price. */
  function goldWait(on) { var c = $('#cart'); if (c) c.classList.toggle('gwait', !!on); }
  function goldFlush() {
    setTimeout(function () {
      if (goldBusy || goldPend || heBusy || lgBusy || !goldGo) return;
      var f = goldGo, b = $('[name=checkout]', f); goldGo = null;
      if (f.requestSubmit && b) f.requestSubmit(b);
      else { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = ''; f.appendChild(i); f.submit(); }
    }, 0);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || (f.id !== 'cart-form' && f.id !== 'kp-cart-form')) return;
    if (e.submitter && e.submitter.name !== 'checkout') return;
    /* a free gift line still owed (the bag was filled before this page read it, or an earlier write failed): write it first.
       Asked at most once every few seconds, so a write that keeps failing never holds the shopper at the bag. */
    if (lgPass) lgPass = false;   // the held tap: it goes through whatever the charm write did
    else if (!lgBusy && cart && Date.now() - lgAsk > 5000 && lgOwed(cart)) {   // Founders Edition charm still owed: put it in first
      lgAsk = Date.now(); e.preventDefault(); e.stopPropagation();
      var go = function () { lgPass = true; goldGo = f; goldFlush(); };
      syncLaunchGift(cart).then(go, go);
      return;
    }
    if (!(goldBusy || goldPend || heBusy) && H && H.on && cart && Date.now() - heAsk > 5000) { var hs = heState(cart); if (hs.due !== !!hs.auto) { heAsk = Date.now(); syncHe(cart); } }
    if (!(goldBusy || goldPend || heBusy || lgBusy)) return;
    e.preventDefault(); e.stopPropagation(); goldGo = f;
    var b = $('[name=checkout]', f); if (b) b.setAttribute('aria-busy', 'true');
  }, true);
  function goldCode() {
    return jfetch(url('/cart.js'), { method: 'GET' }).then(function (c) {
      var list = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      if (list.indexOf(G.code) < 0) list.push(G.code);
      return jfetch(url('/cart/update.js'), { method: 'POST', body: JSON.stringify({ discount: list.join(',') }) });
    }).then(getCart);
  }
  function syncGold(c, mine) {   // mine: called by the claim itself; anything else stands aside while a claim is on its way
    var g = goldLine(c); if (!g || goldBusy || (goldPend && !mine)) return Promise.resolve(c);
    var ok = goldSpend(c) >= goldMin(), free = g.final_line_price === 0;
    var done = function (x) { goldBusy = false; goldFlush(); return x; }, fail = function () { goldBusy = false; goldFlush(); return c; };
    if (ok && free && g.quantity === 1) { goldTries = 0; return Promise.resolve(c); }
    goldBusy = true; goldDirty = true;
    if (ok && free) return jfetch(url('/cart/change.js'), { method: 'POST', body: JSON.stringify({ id: g.key, quantity: 1 }) }).then(function (x) { cart = x; renderCart(); return done(x); }, fail);
    if (ok && goldTries < 2) { goldTries++; return goldCode().then(done, fail).then(function (x) { return syncGold(x, mine); }); }
    return jfetch(url('/cart/change.js'), { method: 'POST', body: JSON.stringify({ id: g.key, quantity: 0 }) })
      .then(function (x) { cart = x; renderCart(); toast(ok ? 'The free box could not be added to this order.' : 'The free ' + esc(G.title) + ' needs ' + fmt(Math.ceil(goldMin() / 100) * 100).replace(/\.00$/, '') + ' in your bag.', 3200); return done(x); }, fail);
  }
  document.addEventListener('click', function (e) {
    var i = e.target.closest('[data-gold-info]'); if (!i) return;
    e.preventDefault(); goldInfoOpen = !goldInfoOpen;
    $$('[data-gold-info]').forEach(function (x) { x.setAttribute('aria-expanded', goldInfoOpen ? 'true' : 'false'); });
    $$('.cg-info').forEach(function (x) { x.hidden = !goldInfoOpen; });
  });
  /* The tap (David, 9 Oct 2026: "way too slow to add"; it took 3.7 s with the bag greyed out). The box shows as added at
     once. Behind it: add.js, then update.js with the code, whose answer is the finished bag (two requests where there were
     four). If either fails the box comes back out and the shopper is told. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gold-claim]'); if (!b || !goldOn() || goldBusy || goldPend) return;
    e.preventDefault(); goldPend = true; goldDirty = true; goldTries = 0; clearTimeout(laterT); goldWait(true); renderCart();
    var codes = [], end = function () { goldPend = false; goldWait(false); };
    // a code already on the bag is kept: read from the bag as last fetched, or fetched now if this page has not read it yet
    (cartLive ? Promise.resolve(cart) : jfetch(url('/cart.js'), { method: 'GET' }))
      .then(function (c0) {
        codes = ((c0 || {}).discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        if (codes.indexOf(G.code) < 0) codes.push(G.code);
        return jfetch(url('/cart/add.js'), { method: 'POST', body: JSON.stringify({ items: [{ id: Number(G.variant), quantity: 1, selling_plan: Number(G.plan), properties: { _kr_gift: 'gold-box' } }] }) });
      })
      .then(function () { return jfetch(url('/cart/update.js'), { method: 'POST', body: JSON.stringify({ discount: codes.join(',') }) }); })
      .then(function (c) { cart = c; goldTries = 1; return syncGold(c, true); })
      .then(function () { end(); renderCart(); goldFlush(); if ($('#kp-gold')) goldPage(); else later(); })
      .catch(function (err) { end(); cartError(err); getCart().then(syncGold).then(goldFlush, goldFlush); });
  });
  if ((goldOn() || (H && H.on)) && $('#kp-gold')) getCart().then(syncGold).then(function (c) { return syncHe(c || cart); }).then(goldPage).catch(function () {});
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]');
    if (q) {
      e.preventDefault();
      var it = (cart.items || []).filter(function (x) { return x.key === q.getAttribute('data-q'); })[0];
      if (it) {
        var n = Math.max(0, it.quantity + Number(q.getAttribute('data-d'))), box = q.parentNode, row = q.closest('.citem');
        if (box && box.classList.contains('qty') && $('span', box)) $('span', box).textContent = n;   // the tap shows at once; prices and steps follow when the store answers
        if (!n && row) row.classList.add('out');
        changeLine(it.key, n);
      }
    }
  });
  var noteT;
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'cart-note') {
      clearTimeout(noteT);
      var v = e.target.value;
      noteT = setTimeout(function () { jfetch(url('/cart/update.js'), { method: 'POST', body: JSON.stringify({ note: v }) }).catch(function () {}); }, 500);
    }
  });
  // a cart change made by anything else on the page (apps, other scripts) refreshes the bag
  (function watchOthers() {
    var re = /\/cart\/(add|change|update|clear)(\.js)?/;
    var of = window.fetch;
    if (of) window.fetch = function (input, init) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var mine = own > 0;
      var p = of.apply(this, arguments);
      // only a change that went through: a failed or rate-limited call (429) must not trigger another read,
      // or two scripts can keep each other busy (seen 25 Sep with Intelligems re-posting its attributes)
      if (!mine && re.test(u)) p.then(function (r) { if (r && r.ok) later(); }, function () {});
      return p;
    };
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) { this._krU = u; return oo.apply(this, arguments); };
    var os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () { if (re.test(this._krU || '')) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) later(); }); return os.apply(this, arguments); };
  })();
  ['cart:refresh', 'cart:updated', 'cart:update', 'ajaxProduct:added'].forEach(function (ev) { document.addEventListener(ev, later); });
  document.addEventListener('kr:open', function (e) { if (e.target && e.target.id === 'cart') { var l = $('#cart-items'); if (l && goldShown) l.scrollTop = 0; if (busy > 0) return;   // opened by an add in flight: that add reads the bag itself
    getCart().then(function (c) { return syncLaunchGift(c || cart); }).then(function (c) { return syncHe(c || cart); }).catch(function () {}); } });
  window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().catch(function () {}); });
  renderCart();
  if (cart && cart.item_count && lgOwed(cart)) later();   // Founders Edition charm owed by a bag filled earlier

  /* ---------------------------------------------------------------- quick add from cards */
  var productCache = {};
  var FULL_PAGE = ['gojo-sukuna-rings'].concat(FINE);   // FINE: the Solid Gold Edition, see the top of the file
  function productJSON(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return jfetch(url('/products/' + handle + '.js'), { method: 'GET' }).then(function (p) { productCache[handle] = p; return p; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qa]'); if (!b) return;
    e.preventDefault();
    var handle = b.getAttribute('data-qa');
    if (!b.hasAttribute('data-multi')) {
      b.classList.add('busy');
      addItems([{ id: Number(b.getAttribute('data-vid')), quantity: 1 }]).then(function () { b.classList.remove('busy'); }, function () { b.classList.remove('busy'); });
      return;
    }
    /* the Gojo x Sukuna set asks for the second ring's metal and both ring sizes through the Globo Product Options
       app, which only runs on the product page, so quick add sends shoppers there instead of adding it without sizes */
    if (FULL_PAGE.indexOf(handle) > -1) { location.href = url('/products/' + handle); return; }
    b.classList.add('busy');
    productJSON(handle).then(function (p) {
      var row = b.closest('[data-wh]');
      /* Wishlist prices arrive from the theme fragment: wait for its eligibility before opening the sheet. */
      return Promise.resolve(row && row._krPriceReady).then(function (ready) {
        b.classList.remove('busy');
        if (row && !ready) { location.href = url('/products/' + handle); return; }
        quickSheet(p, b);
      });
    }, function () { b.classList.remove('busy'); location.href = url('/products/' + handle); });
  });
  /* Intelligems (Sep 2026): prices are wrapped in the same priceContainer as snippets/kr-price.liquid (KRIG.wrap from
     kr-ig-price-sync.js), so a price test also reaches the quick-add sheet and the product page after a variant switch.
     The wrapper is display: contents, so the layout is exactly as before. Eligibility comes from the card's container
     (data-kr-disc, which already honours the no-sitewide-discount tag) when there is one. */
  /* The bag takes the tier percentage (20) off instead of the sitewide one (15) once it reaches the tier, so a price that
     reaches the tier on its own is shown at the tier percentage: the price the bag charges (8 Oct 2026, snippets/kr-keep). */
  /* A launch offer piece (h = its handle) takes its own launch percentage while the offer runs, by the shopper's clock: the bag gives
     its line that one product discount (snippets/kr-launch-pct, window.KR.launch, 19 Oct 2026). */
  function launchPct(h) { var L = K.launch, t = Date.now(); if (!L || !h) return 0; if (L.h && L.h[h] && t >= L.s && t < L.e) return Number(L.h[h]); return L.o && L.o[h] && t >= L.os ? Number(L.o[h]) : 0; }   // o: no end (Founders Edition 25 Oct)
  function pctOf(c, h) { var T = K.tiers || {}; return launchPct(h) || (K.pct && K.tierPct > K.pct && T.dtier > 0 && c >= T.dtier ? K.tierPct : (K.pct || 0)); }
  K.pctOf = pctOf;   // the percentage a card shows for a price (launch, tier or sitewide), for the bag's add-on row
  function igWrap(v, pid, elig, inner, h) {
    if (!window.KRIG || !pid) return inner;
    return window.KRIG.wrap({ vid: v.id, pid: pid, disc: !!(elig && K.pct), pct: pctOf(v.price, h), base: v.price, inner: inner });
  }
  function priceHTML(v, card, pid, h) {
    var pc = card && card.querySelector('[data-kr-ig]');
    var elig = pc ? pc.getAttribute('data-kr-disc') === '1' : (card && card.querySelector('s[data-was]') ? true : false);
    var now = v.price, was = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
    if (elig && K.pct) { was = Math.max(was, v.price); now = Math.ceil(v.price * (100 - pctOf(v.price, h)) / 100); }
    return igWrap(v, pid, elig, (was > now ? '<s data-was>' + fmt(was) + '</s> ' : '') + '<b data-now>' + fmt(now) + '</b>', h);
  }
  function quickSheet(p, btn) {
    var card = btn.closest('.pcard,.citem');
    var sel = (p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]).options.slice();
    var body = $('#quick-body'); if (!body) return;
    function variant() { return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]; }
    function draw() {
      var v = variant();
      var im = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      body.innerHTML = '<div class="qtop"><img src="' + esc(img(im, 200)) + '" alt=""><div><b>' + esc(p.title) + '</b><div class="kprice" style="margin-top:4px">' + (v ? priceHTML(v, card, p.id, p.handle) : '') + '</div></div></div>' +
        p.options.map(function (o, i) {
          var isz = /size/i.test(o.name);
          return '<div class="qopt"' + (isz ? ' data-size style="--n:' + Math.min(o.values.length, 3) + '"' : '') + '><div class="lab">' + esc(o.name) + ': <b style="color:var(--ink)">' + esc(isz ? sizeParts(sel[i])[0] : sel[i]) + '</b></div><div class="pills" role="radiogroup" aria-label="' + esc(o.name) + '">' +
            o.values.map(function (val) {
              var test = sel.slice(); test[i] = val;
              var ok = p.variants.some(function (v2) { return v2.available && v2.options.every(function (x, j) { return x === test[j]; }); });
              var sp = isz ? sizeParts(val) : null;
              return '<button type="button" class="mpill' + (isz ? ' szp' : '') + (val === sel[i] ? ' on' : '') + '" role="radio" aria-checked="' + (val === sel[i] ? 'true' : 'false') + '" data-i="' + i + '" data-v="' + esc(val) + '"' + (ok ? '' : ' disabled') + '>' + (sp ? '<b>' + esc(sp[0]) + '</b>' + (sp[1] ? '<small>' + esc(sp[1]) + '</small>' : '') : esc(val)) + '</button>';
            }).join('') + '</div></div>';
        }).join('') +
        '<button type="button" class="btn" id="quick-add"' + (v && v.available ? '' : ' disabled') + '>' + (v && v.available ? 'Add to bag' : 'Sold out') + '</button>' +
        '<a class="link" style="display:block;text-align:center;margin-top:12px;font-size:14px" href="' + esc(p.url) + '">View full details</a>';
    }
    draw();
    body.onclick = function (e) {
      var pill = e.target.closest('.mpill');
      if (pill && !pill.disabled) { sel[Number(pill.getAttribute('data-i'))] = pill.getAttribute('data-v'); draw(); return; }
      if (e.target.closest('#quick-add')) {
        var v = variant(); if (!v) return;
        var bt = e.target.closest('#quick-add'); bt.disabled = true; bt.textContent = 'Adding...';
        addItems([{ id: v.id, quantity: 1 }]).catch(function () { bt.disabled = false; bt.textContent = 'Add to bag'; });
      }
    };
    K.open('quick');
  }

  /* ---------------------------------------------------------------- product page */
  /* David, 24 Sep (round 58): metal reads "18K gold" / "925 sterling silver" wherever the colour is named */
  /* David, 28 Sep: rose gold reads "18K rose gold", black reads "Royal Black" */
  function metal(s) { return /rose/i.test(s) ? '18K rose gold' : /black/i.test(s) ? 'Royal Black' : /gold/i.test(s) ? '18K gold' : /silver/i.test(s) ? '925 sterling silver' : s; }
  /* ring sizes (26 Sep): "Small (US 4-8)" shows as "Small" over "Fits US 4-8" */
  function sizeParts(s) {
    var m = /^(.*?)\s*\((.*)\)\s*$/.exec(s || '');
    if (!m) return [s, ''];
    return [m[1].replace(/\s+ring$/i, ''), 'Fits ' + m[2].replace(/US\s*/i, 'US ')];
  }
  /* no photo linked to a variant: the first photo whose file name or description names its metal, e.g. "set-silver" */
  function metalMedia(title, list, key) {
    var mt = /rose/i.test(title) ? /rose/i : /black/i.test(title) ? /black/i : /silver/i.test(title) ? /silver/i : /gold/i.test(title) ? /gold/i : null;
    return mt ? (list || []).filter(function (m) { return mt.test(key(m)); })[0] : null;
  }
  /* Globo Product Options (the Sukuna ring's metal and both ring sizes on the Gojo x Sukuna set): the app draws its
     own buttons after load, so they are dressed in the theme's pills and labels here, and again if the app redraws */
  /* the app's choices start on their first option (Gold, Small) so nobody is stopped from adding to bag (David, 26 Sep);
     clicking the radio lets the app record the value in its own hidden fields */
  function gpoDefaults(root) {
    $$('.gpo-element', root).forEach(function (el) {
      var rs = $$('input[type=radio]', el);
      if (rs.length && !rs.some(function (r) { return r.checked; })) rs[0].click();
    });
  }
  function dressGpo(root) {
    $$('.gpo-element', root).forEach(function (el) {
      if (el.hasAttribute('data-kr')) return;
      var radios = $$('input[type=radio]', el), nameEl = $('.gpo-label .label-content', el);
      if (!radios.length || !nameEl) return;
      el.setAttribute('data-kr', '');
      var name = nameEl.textContent.trim();
      var isMetal = radios.some(function (r) { return /gold|silver|black/i.test(r.value); }), isSize = /size/i.test(name);
      el.classList.add('kr-gopt');
      if (isMetal) el.classList.add('kr-gmetal');
      if (isSize) { el.classList.add('kr-gsize'); el.style.setProperty('--n', Math.min(radios.length, 3)); }
      var head = document.createElement('div'); head.className = 'lab kr-glab';
      head.innerHTML = '<span>' + esc(name) + ':<b data-gcur></b></span>' + (isSize && document.getElementById('size-sheet') ? '<button type="button" class="link" data-open="size-sheet">Size guide</button>' : '');
      el.insertBefore(head, el.firstChild);
      radios.forEach(function (r) {
        var t = r.nextElementSibling && $('.gpo-ov-title', r.nextElementSibling); if (!t) return;
        if (isSize) { var sp = sizeParts(r.value); t.innerHTML = '<b>' + esc(sp[0]) + '</b>' + (sp[1] ? '<small>' + esc(sp[1]) + '</small>' : ''); }
        else if (isMetal) t.insertAdjacentHTML('afterbegin', '<i class="mdot ' + (/rose/i.test(r.value) ? 'rose' : /black/i.test(r.value) ? 'black' : /gold/i.test(r.value) ? 'gold' : 'silver') + '"></i>');
      });
      function cur() {
        var c = radios.filter(function (r) { return r.checked; })[0], b = $('[data-gcur]', head);
        b.textContent = c ? (isMetal ? metal(c.value) : isSize ? sizeParts(c.value)[0] : c.value) : 'Choose one';
        b.classList.toggle('pick', !c);
        var m = $('.messages', el); if (c && m) m.textContent = '';
      }
      el.addEventListener('change', cur); cur();
      /* the app's own heading ("SUKUNA RING:") repeats the label now shown above the pills */
      var prev = el.previousElementSibling;
      if (prev && $('.gpo-paragraph', prev) && prev.textContent.trim().replace(/:$/, '').toLowerCase() === name.toLowerCase()) prev.classList.add('kr-ghide');
    });
  }
  $$('[data-pform]').forEach(function (form) {
    var data = {}; try { data = JSON.parse($('script[type="application/json"]', form).textContent); } catch (e) { return; }
    var p = data.product; if (!p) return;
    var elig = !!data.eligible;
    var sel = (p.variants.filter(function (v) { return v.id === data.selected; })[0] || p.variants[0]).options.slice();
    var idInput = $('input[name="id"]', form);
    var btns = $$('[data-atc]', document);
    var planInput = $('input[name="selling_plan"]', form);
    /* colour switch is instant (David, 25 Sep): the other colours' photos are fetched quietly once the page has loaded */
    var TILE_SIZES = '(min-width: 900px) 215px, 30vw';
    function tileSet(u) { var q = u.indexOf('?') > -1 ? '&' : '?'; return [300, 450, 600].map(function (w) { return u + q + 'width=' + w + ' ' + w + 'w'; }).join(', '); }
    function warmVariants() {
      p.variants.forEach(function (v2) {
        if (!v2.featured_image) return;
        var u = v2.featured_image.src || v2.featured_image, im = new Image(); im.sizes = TILE_SIZES; im.srcset = tileSet(u);
        if (v2.featured_media) { var sl = $('[data-media-id="' + v2.featured_media.id + '"] img'); if (sl) sl.loading = 'eager'; }
      });
      $$('[data-media-id] img').forEach(function (im) { if (/gold|silver|black/i.test(im.getAttribute('alt') || '')) im.loading = 'eager'; });
    }
    /* called on window: an unbound requestIdleCallback throws 'Illegal invocation' (audit, 25 Sep) */
    var warmIt = function () { if (window.requestIdleCallback) window.requestIdleCallback(warmVariants, { timeout: 1500 }); else window.setTimeout(warmVariants, 1); };
    if (document.readyState === 'complete') warmIt(); else window.addEventListener('load', warmIt);
    form.addEventListener('pointerover', function (e) { if (e.target.closest('.mpill')) warmVariants(); }, { once: true });
    function current() { return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]; }
    function sale(v) { return elig && K.pct ? Math.ceil(v.price * (100 - pctOf(v.price, p.handle)) / 100) : v.price; }
    function update(push) {
      var v = current();
      $$('[data-opt-i]', form).forEach(function (grp) {
        var i = Number(grp.getAttribute('data-opt-i'));
        var cur = $('[data-opt-cur]', grp); if (cur) cur.textContent = grp.hasAttribute('data-metal') ? metal(sel[i]) : grp.hasAttribute('data-size') ? sizeParts(sel[i])[0] : sel[i];
        $$('.mpill', grp).forEach(function (b) {
          var val = b.getAttribute('data-v'); b.classList.toggle('on', val === sel[i]); b.setAttribute('aria-checked', val === sel[i] ? 'true' : 'false'); /* screen readers hear the new choice (audit, 25 Sep) */
          var test = sel.slice(); test[i] = val;
          var ok = p.variants.some(function (v2) { return v2.available && v2.options.every(function (x, j) { return x === test[j]; }); });
          b.classList.toggle('na', !ok);
        });
      });
      if (!v) { btns.forEach(function (b) { b.disabled = true; var l = $('span', b); if (l) l.textContent = 'Unavailable'; }); return; }
      if (idInput) idInput.value = v.id;
      var now = sale(v), was = Math.max(v.compare_at_price || 0, elig ? v.price : 0);
      var priceInner = igWrap(v, p.id, elig, (was > now ? '<s data-was>' + fmt(was) + '</s> ' : '') + '<b data-now>' + fmt(now) + '</b>', p.handle);
      $$('[data-pprice]').forEach(function (el) { el.innerHTML = priceInner; });
      $$('[data-sezzle]').forEach(function (el) { el.textContent = fmt(Math.ceil(now / 4)); });
      $$('[data-ppc]').forEach(function (el) { el.textContent = fmt(Math.ceil(now / Number(el.getAttribute('data-ppc')))) + '/pc'; });
      $$('[data-vtitle]').forEach(function (el) { el.textContent = v.title === 'Default Title' ? '' : metal(v.title); });
      var vim = v.featured_image ? (v.featured_image.src || v.featured_image) : ((metalMedia(v.title, p.media, function (m) { return (m.src || '') + ' ' + (m.alt || ''); }) || {}).src || '');
      if (vim) $$('[data-vimg] img').forEach(function (im) { im.sizes = TILE_SIZES; im.srcset = tileSet(vim); im.src = vim + (vim.indexOf('?') > -1 ? '&' : '?') + 'width=600'; });
      btns.forEach(function (b) {
        b.disabled = !v.available;
        var l = $('span', b); if (l) l.textContent = v.available ? (b.getAttribute('data-label') || 'Add to bag') : 'Sold out';
      });
      if (data.media) {
        var slide = v.featured_media ? $('[data-media-id="' + v.featured_media.id + '"]') : null;
        /* no photo linked to the variant (common on sets): use the first photo whose description names the metal, e.g. "set silver" */
        if (!slide) slide = metalMedia(v.title, $$('[data-media-id]'), function (el) { var im = $('img', el); return im ? (im.getAttribute('alt') || '') + ' ' + (im.getAttribute('src') || '') : ''; }) || null;
        if (slide && slide.parentNode) { slide.parentNode.scrollTo({ left: slide.offsetLeft, behavior: push ? 'smooth' : 'auto' }); }
      }
      if (push && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      form.dispatchEvent(new CustomEvent('kr:variant', { detail: v, bubbles: true }));
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('.mpill[data-v]'); if (!b || !form.contains(b)) return;
      var grp = b.closest('[data-opt-i]'); if (!grp) return;
      e.preventDefault(); sel[Number(grp.getAttribute('data-opt-i'))] = b.getAttribute('data-v'); update(true);
    });
    // subscription plans (Collector Club): a plan card sets the selling plan, "one box" clears it
    $$('[data-plan]', form).forEach(function (pl) {
      pl.addEventListener('click', function () {
        $$('[data-plan]', form).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-checked', 'false'); });
        pl.classList.add('on'); pl.setAttribute('aria-checked', 'true');
        if (planInput) planInput.value = pl.getAttribute('data-plan') || '';
        var vid = pl.getAttribute('data-variant'); if (vid && idInput) idInput.value = vid;
        btns.forEach(function (b) { var l = $('span', b); if (l && pl.getAttribute('data-cta')) { l.textContent = pl.getAttribute('data-cta'); b.setAttribute('data-label', pl.getAttribute('data-cta')); } });
      });
    });
    // hand engraving: text fields, then a separate engraving line joined to this piece
    var eng = $('[data-eng]', form);
    if (eng) {
      var on = $('[data-eng-on]', eng);
      on.addEventListener('change', function () { eng.classList.toggle('on', on.checked); });
      $$('[data-eng-text]', eng).forEach(function (i) { i.addEventListener('input', function () { var c = $('[data-cnt="' + i.id + '"]', eng); if (c) c.textContent = i.value.length + '/' + i.maxLength; }); });
    }
    function submit(e) {
      if (e) e.preventDefault();
      var v = current(); if (!v || !v.available) return;
      gpoDefaults(form); /* never block the add: an untouched choice goes in as its first option (David, 26 Sep) */
      var qty = Number(($('[name=quantity]', form) || {}).value || 1);
      var line = { id: Number(idInput ? idInput.value : v.id), quantity: qty };
      if (planInput && planInput.value) line.selling_plan = Number(planInput.value);
      var props = {};
      $$('[name^="properties["]', form).forEach(function (f) { if (f.value && !(f.type === 'checkbox' && !f.checked)) props[f.name.slice(11, -1)] = f.value; });
      var items = [];
      if (eng && $('[data-eng-on]', eng).checked && K.engrave && K.engrave.variant) {
        var texts = $$('[data-eng-text]', eng).map(function (i) { return (i.getAttribute('data-label') || 'Engraving') + ': ' + i.value.trim(); }).filter(function (s) { return !/: $/.test(s); });
        if (!texts.length) { toast('Add the words you want engraved first'); var fi = $('[data-eng-text]', eng); if (fi) fi.focus(); return; }
        props['Engraving'] = texts.join(' / ');
        items.push({ id: Number(K.engrave.variant), quantity: qty, properties: { 'For': p.title, 'Text': texts.join(' / ') } });
      }
      if (Object.keys(props).length) line.properties = props;
      items.unshift(line);
      form.dispatchEvent(new CustomEvent('kr:items', { detail: { items: items, qty: qty } }));   // add-on rows add their own line here (snippets/kr-chain-addon: the chain on charm pages, 2 Nov 2026)
      btns.forEach(function (b) { b.classList.add('busy'); b.disabled = true; });
      addItems(items).then(done, done);
      function done() { btns.forEach(function (b) { b.classList.remove('busy'); b.disabled = false; }); update(false); }
    }
    form.addEventListener('submit', submit);
    btns.forEach(function (b) { if (!form.contains(b)) b.addEventListener('click', submit); });
    dressGpo(form); gpoDefaults(form);
    /* a timer, not requestAnimationFrame: frames never fire in a background tab, so a page opened there kept the app's raw buttons */
    if (window.MutationObserver) { var gq = 0; new MutationObserver(function () { if (gq) return; gq = setTimeout(function () { gq = 0; dressGpo(form); gpoDefaults(form); }, 30); }).observe(form, { childList: true, subtree: true }); }
    update(false);
  });
  // gallery: thumbnails scroll the track, the counter follows
  $$('.gal').forEach(function (g) {
    var tr = $('.track', g); if (!tr) return;
    var th = $$('.thumbs button', g), cnt = $('.gcount', g), n = $$('.slide', tr).length;
    th.forEach(function (b, i) { b.addEventListener('click', function () { var s = $$('.slide', tr)[i]; if (s) tr.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }); });
    var t;
    tr.addEventListener('scroll', function () {
      clearTimeout(t); t = setTimeout(function () {
        var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
        th.forEach(function (b, k) { b.classList.toggle('on', k === i); });
        if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
        $$('video', tr).forEach(function (v, k) { if (!v.paused) v.pause(); });
      }, 60);
    }, { passive: true });
  });
  // sticky add to bag
  var atc = $('#atc'), sticky = $('.stickyatc');
  if (atc && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { var e = en[0]; sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(atc);
  }

  /* ---------------------------------------------------------------- announcement: alternate with the sale countdown */
  (function () {
    var bar = $('[data-ann]'), cd = bar && $('[data-cd]', bar); if (!cd) return;
    var end = Date.parse(cd.getAttribute('data-cd')), out = $('[data-cdt]', cd), items = $$('.an-i', bar), k = 0;
    if (!end || end <= Date.now()) return;
    cd.hidden = false;
    var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!s) { cd.remove(); items = $$('.an-i', bar); items.forEach(function (x) { x.classList.add('on'); }); clearInterval(t1); clearInterval(t2); return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sc = s % 60;
      out.textContent = (d ? d + 'd ' : '') + p2(h) + 'h ' + p2(m) + 'm ' + p2(sc) + 's';
    }
    tick();
    var t1 = setInterval(tick, 1000);
    var t2 = setInterval(function () { items[k].classList.remove('on'); k = (k + 1) % items.length; items[k].classList.add('on'); }, 4500);
  })();

  /* ---------------------------------------------------------------- wishlist */
  var WK = 'kr-wish';
  function wlist() { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; } }
  function wsave(l) { try { localStorage.setItem(WK, JSON.stringify(l)); } catch (e) {} paintWish(); }
  function wHas(h) { return wlist().some(function (x) { return x.h === h; }); }
  function paintWish() {
    var l = wlist();
    $$('[data-wish-count]').forEach(function (b) { b.textContent = l.length; b.classList.toggle('on', l.length > 0); });
    $$('[data-wish-count2]').forEach(function (b) { b.textContent = l.length || ''; });
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', wHas(b.getAttribute('data-wish')) ? 'true' : 'false'); });
  }
  function cardSnapshot(h, btn) {
    var c = btn && btn.closest('.pcard,[data-pform],.bb');
    var s = { h: h, t: '', i: '', p: '' };
    if (c) {
      var t = $('.n,h1', c); s.t = t ? t.textContent.trim() : '';
      var im = $('img', c.closest('.pdp') || c); s.i = im ? (im.currentSrc || im.src) : '';
      var pr = $('.kprice,[data-pprice]', c); s.p = pr ? pr.innerHTML : '';
    }
    return s;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), l = wlist();
    if (wHas(h)) { wsave(l.filter(function (x) { return x.h !== h; })); toast('Removed from your wishlist'); }
    else {
      var s = cardSnapshot(h, b); l.unshift(s); wsave(l);
      toast('Saved to your wishlist <a href="#" data-open="wish">View</a>', 2600);
      try { if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track', 'Added to Wishlist', { Handle: h, Title: s.t, URL: location.origin + url('/products/' + h) }]); } catch (err) {}
    }
  });
  var sharedList = null;
  (function () { var q = new URLSearchParams(location.search).get('wishlist'); if (q) { sharedList = q.split(',').filter(Boolean).slice(0, 40); setTimeout(function () { K.open('wish'); }, 400); } })();
  function renderWish() {
    var box = $('#wish-items'); if (!box) return;
    var shared = !!sharedList, handles = shared ? sharedList : wlist().map(function (x) { return x.h; });
    $('#wish-shared') && $('#wish-shared').classList.toggle('hidden', !shared);
    if (!handles.length) { box.innerHTML = '<div class="cempty"><div class="cttl">Nothing saved yet</div>Tap the heart on any piece to save it here.<div style="margin-top:18px"><a class="btn" href="' + url('/collections/jewelry') + '">Shop best sellers</a></div></div>'; return; }
    box.innerHTML = handles.map(function (h) { return '<div class="citem" data-wh="' + esc(h) + '"><span class="ph" style="width:64px;height:64px"></span><div class="ci"><div class="t">&nbsp;</div></div></div>'; }).join('');
    handles.forEach(function (h) {
      productJSON(h).then(function (p) {
        var row = box.querySelector('[data-wh="' + h + '"]'); if (!row) return;
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        var price = '<b>' + fmt(v.price) + '</b>';
        row.innerHTML = '<a href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 160)) + '" alt="" width="64" height="64" loading="lazy"></a><div class="ci"><a class="t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="kprice" style="font-size:13.5px;margin-top:3px">' + price + '</div>' +
          (p.available ? (p.variants.length > 1 ? '<button type="button" class="add" data-qa="' + esc(h) + '" data-vid="' + v.id + '" data-multi>Choose options</button>' : '<button type="button" class="add" data-qa="' + esc(h) + '" data-vid="' + v.id + '">Add to bag</button>') : '<div class="v">Sold out</div>') +
          '</div>' + (shared ? '<button type="button" class="x" data-wish="' + esc(h) + '" aria-label="Save to my wishlist">' + '&#9825;' + '</button>' : '<button type="button" class="x" data-wish="' + esc(h) + '" aria-label="Remove from wishlist">&times;</button>');
        /* the sale price the card shows (15% where it applies), from the theme, so the wishlist never shows full price by mistake */
        row._krPriceReady = fetch(url('/products/' + h) + '?view=krw').then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) { var k = row.querySelector('.kprice'); if (k && t && t.indexOf('data-now') > -1) { k.innerHTML = t.replace(/^[\s\S]*?<span class="kprice"[^>]*>|<\/span>\s*$/g, ''); return true; } return false; }).catch(function () { return false; });
      }, function () {
        /* a failed request (offline, blocked, renamed product) must not wipe a saved piece: keep it and show what we saved (audit, 25 Sep) */
        var row = box.querySelector('[data-wh="' + h + '"]'); if (!row) return;
        var saved = wlist().filter(function (x) { return x.h === h; })[0] || { t: h };
        row.innerHTML = '<a href="' + esc(url('/products/' + h)) + '">' + (saved.i ? '<img src="' + esc(saved.i) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="ph" style="width:64px;height:64px"></span>') + '</a><div class="ci"><a class="t" href="' + esc(url('/products/' + h)) + '">' + esc(saved.t || h) + '</a><div class="v">Couldn&#8217;t load right now</div></div>' +
          (shared ? '' : '<button type="button" class="x" data-wish="' + esc(h) + '" aria-label="Remove from wishlist">&times;</button>');
      });
    });
  }
  document.addEventListener('kr:open', function (e) { if (e.target && e.target.id === 'wish') renderWish(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('#wish-share')) {
      var hs = (sharedList || wlist().map(function (x) { return x.h; }));
      if (!hs.length) { toast('Save a piece first'); return; }
      var link = location.origin + url('/') + '?wishlist=' + hs.join(',');
      if (navigator.share) { navigator.share({ title: 'My Kraymer Art wishlist', url: link }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(link).then(function () { toast('Link copied'); }); }
      else { prompt('Copy this link', link); }
    }
    if (e.target.closest('#wish .x') && !sharedList) setTimeout(renderWish, 30);
  });
  paintWish();
  document.addEventListener('kr:cards', paintWish);

  /* ---------------------------------------------------------------- predictive search */
  var sIn = $('#kr-q'), sRes = $('#search-res'), sDef = sRes ? sRes.innerHTML : '', sT, sCtl;
  if (sIn && sRes) {
    sIn.addEventListener('input', function () {
      clearTimeout(sT);
      var q = sIn.value.trim();
      if (q.length < 2) { sRes.innerHTML = sDef; return; }
      sT = setTimeout(function () {
        if (sCtl && sCtl.abort) sCtl.abort();
        sCtl = window.AbortController ? new AbortController() : null;
        fetch(url('/search/suggest') + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=kr-predictive', { signal: sCtl && sCtl.signal })
          .then(function (r) { return r.text(); })
          .then(function (t) { var d = document.createElement('div'); d.innerHTML = t; var inner = d.querySelector('[data-pred]'); sRes.innerHTML = inner ? inner.innerHTML : sDef; })
          .catch(function () {});
      }, 180);
    });
  }

  /* ---------------------------------------------------------------- collection filters and sort */
  var RANK = (K.rank || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var RI = {}; RANK.forEach(function (h, i) { RI[h] = i; });
  var STOP = ('necklace necklaces ring rings bracelet bracelets earring earrings pin pins enamel glow dark pendant pendants locket keychain set sets collection jewelry jewellery silver gold sterling 925 18k full couple couples matching adjustable spinning charm charms chain the and with for a of in on 3in1 2in1 3-in-1 2-in-1 1 2 3 box mystery gift art print bag ita hard').split(' ');
  function charTokens(title) {
    var parts = String(title).toLowerCase().replace(/[’']/g, '').split(/\s+x\s+|\s*&\s*|\s*\+\s*|\s+and\s+|\s*,\s*/);
    var out = [];
    parts.forEach(function (part) {
      var w = part.replace(/[^a-z0-9\s-]/g, ' ').split(/[\s-]+/).filter(Boolean).filter(function (x) { return STOP.indexOf(x) === -1; });
      if (w.length) out.push(w[0]);
    });
    return out;
  }
  function rankOf(c) { var h = c.getAttribute('data-h'); return h in RI ? RI[h] : 900 + Number(c.getAttribute('data-def') || 0); }
  function groupedOrder(cards) {
    // David, 25 Sep: organised by character by default. A set leads its family; families sort by their best seller.
    var items = cards.map(function (c) { return { c: c, chars: charTokens(c.getAttribute('data-t')), r: rankOf(c), set: /\bset\b/.test(c.getAttribute('data-tags')), av: c.getAttribute('data-avail') !== '0' }; });
    var best = {};
    items.forEach(function (it) { it.chars.forEach(function (ch) { if (!(ch in best) || it.r < best[ch]) best[ch] = it.r; }); });
    function key(it) { if (!it.chars.length) return '~'; var k = it.chars[0]; it.chars.forEach(function (ch) { if (best[ch] < best[k]) k = ch; }); return k; }
    var groups = {}, order = [];
    items.forEach(function (it) { var k = key(it); if (!groups[k]) { groups[k] = []; order.push(k); } groups[k].push(it); });
    order.forEach(function (k) { groups[k].sort(function (a, b) { if (a.av !== b.av) return a.av ? -1 : 1; if (a.set !== b.set) return a.set ? -1 : 1; return a.r - b.r; }); });
    function soldOut(k) { return groups[k].every(function (it) { return !it.av; }) ? 1 : 0; }
    order.sort(function (a, b) { if (a === '~') return 1; if (b === '~') return -1; var s = soldOut(a) - soldOut(b); if (s) return s; return Math.min.apply(null, groups[a].map(function (x) { return x.r; })) - Math.min.apply(null, groups[b].map(function (x) { return x.r; })); });
    var sat = {};
    items.forEach(function (it) { if (it.chars.length < 2) return; var home = key(it); it.chars.forEach(function (ch) { if (ch !== home && groups[ch]) { (sat[home] = sat[home] || []).indexOf(ch) === -1 && sat[home].push(ch); } }); });
    var out = [], done = {};
    function emit(k) { if (done[k] || !groups[k]) return; done[k] = 1; groups[k].forEach(function (x) { out.push(x.c); }); (sat[k] || []).forEach(emit); }
    order.forEach(emit);
    return out;
  }
  $$('[data-kgrid]').forEach(function (wrap) {
    var grid = $('.pgrid', wrap), count = $('[data-count]', wrap), sortSel = $('[data-sort]', wrap);
    var state = { world: 'all', piece: 'all' };
    var pinsLoaded = false, pinsUrl = wrap.getAttribute('data-pins');
    function cards() { return $$('.pcard', grid); }
    // pins show under "All" only on a page that is all pins (a pins collection); elsewhere they wait for the Pins tile
    var onlyPins = !cards().some(function (c) { return (c.getAttribute('data-tags') || '').split(' ').indexOf('pin') === -1; });
    var SERIES = []; $$('[data-dim="world"] [data-f]', wrap).forEach(function (b) { var k = b.getAttribute('data-f'); if (k !== 'all') SERIES.push({ k: k, l: k === 'other' ? 'More pins' : b.textContent.trim() }); });
    if (SERIES.length && !SERIES.some(function (s) { return s.k === 'other'; })) SERIES.push({ k: 'other', l: 'More pins' });
    function apply() {
      var n = 0;
      cards().forEach(function (c) {
        var t = (c.getAttribute('data-tags') || '').split(' ');
        var ok = (state.world === 'all' || t.indexOf(state.world) > -1) && (state.piece === 'all' ? (onlyPins || t.indexOf('pin') === -1) : t.indexOf(state.piece) > -1);
        c.classList.toggle('hidden', !ok); if (ok) n++;
      });
      $$('.edtile,.gspan', grid).forEach(function (t) { t.classList.toggle('hidden', state.world !== 'all' || state.piece !== 'all'); });
      $$('.gser', grid).forEach(function (h) { var m = 0, x = h.nextElementSibling; while (x && !x.classList.contains('gser')) { if (x.classList.contains('pcard') && !x.classList.contains('hidden')) m++; x = x.nextElementSibling; } h.classList.toggle('hidden', state.world !== 'all' || !m); $('span', h).textContent = m + (m === 1 ? ' pin' : ' pins'); });
      if (count) count.textContent = n + (n === 1 ? ' piece' : ' pieces');
      var none = $('.gnone', grid);
      if (!n && !none) { none = document.createElement('div'); none.className = 'gnone'; none.textContent = 'Nothing here yet. Try another filter.'; grid.appendChild(none); }
      if (none) none.classList.toggle('hidden', n > 0);
    }
    function sort(k) {
      var list = cards();
      var cmp = { best: function (a, b) { return rankOf(a) - rankOf(b); }, low: function (a, b) { return a.getAttribute('data-p') - b.getAttribute('data-p'); }, high: function (a, b) { return b.getAttribute('data-p') - a.getAttribute('data-p'); },
        new: function (a, b) { return b.getAttribute('data-new') - a.getAttribute('data-new'); }, az: function (a, b) { return a.getAttribute('data-t').localeCompare(b.getAttribute('data-t')); }, za: function (a, b) { return b.getAttribute('data-t').localeCompare(a.getAttribute('data-t')); } }[k];
      var sorted = cmp ? list.slice().sort(cmp) : groupedOrder(list);
      /* 28 Oct 2026: lead cards (data-lead, the grid's lead_handles, e.g. the Sorcerer Watches) open the default order */
      if (!cmp) sorted = sorted.filter(function (c) { return c.hasAttribute('data-lead'); }).sort(function (a, b) { return a.getAttribute('data-def') - b.getAttribute('data-def'); }).concat(sorted.filter(function (c) { return !c.hasAttribute('data-lead'); }));
      var tiles = $$('.edtile,.gspan', grid);
      $$('.gser', grid).forEach(function (h) { h.remove(); });
      // pins page, default sort: "All" is organised by series, each under its own heading (David, 26 Sep)
      if (!cmp && onlyPins && SERIES.length) {
        var bucket = {}; SERIES.forEach(function (s) { bucket[s.k] = []; });
        sorted.forEach(function (c) { var t = (c.getAttribute('data-tags') || '').split(' '), k = 'other'; SERIES.forEach(function (s) { if (s.k !== 'other' && k === 'other' && t.indexOf(s.k) > -1) k = s.k; }); (bucket[k] || bucket.other || (bucket.other = [])).push(c); });
        sorted = [];
        SERIES.forEach(function (s) { var g = bucket[s.k] || []; if (!g.length) return; var h = document.createElement('div'); h.className = 'gser'; h.setAttribute('data-ser', s.k); h.innerHTML = '<h3 class="d">' + s.l + '</h3><span></span>'; sorted.push(h); sorted = sorted.concat(g); });
        tiles = [];
      }
      sorted.forEach(function (c) { grid.appendChild(c); });
      // editorial tiles go back after the 4th and 12th card
      tiles.forEach(function (t, i) { var at = grid.children[i === 0 ? 4 : 12 + 1]; if (at) grid.insertBefore(t, at); else grid.appendChild(t); });
      var none = $('.gnone', grid); if (none) grid.appendChild(none);
    }
    function loadPins() {
      if (pinsLoaded || !pinsUrl) return Promise.resolve();
      pinsLoaded = true; wrap.classList.add('loading');
      return fetch(pinsUrl).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) {
        var d = document.createElement('div'); d.innerHTML = t;
        var have = {}; cards().forEach(function (c) { have[c.getAttribute('data-h')] = 1; });
        $$('.pcard', d).forEach(function (c) { if (!have[c.getAttribute('data-h')]) { c.classList.remove('hidden'); grid.appendChild(c); } });
        paintWish(); sort(sortSel ? sortSel.value : 'def'); wrap.classList.remove('loading');
      }, function () { pinsLoaded = false; wrap.classList.remove('loading'); });
    }
    $$('[data-dim]', wrap).forEach(function (row) {
      var dim = row.getAttribute('data-dim');
      $$('[data-f]', row).forEach(function (ch) {
        ch.addEventListener('click', function (e) {
          e.preventDefault();
          $$('[data-f]', row).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
          ch.classList.add('on'); ch.setAttribute('aria-pressed', 'true');
          state[dim] = ch.getAttribute('data-f');
          var go = state.piece === 'pin' ? loadPins() : Promise.resolve();
          go.then(apply);
          if (history.replaceState) { var u = new URL(location.href); if (state[dim] === 'all') u.searchParams.delete(dim); else u.searchParams.set(dim, state[dim]); history.replaceState({}, '', u.toString()); }
        });
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { sort(sortSel.value); apply(); });
    sort('def'); apply();
    var qs = new URLSearchParams(location.search);
    ['piece', 'world'].forEach(function (d) {
      var v = qs.get(d); if (!v) return;
      var c = $('[data-dim="' + d + '"] [data-f="' + v + '"]', wrap);
      if (c) { c.click(); setTimeout(function () { var y = wrap.getBoundingClientRect().top + scrollY - 80; scrollTo({ top: y }); }, 80); }
    });
  });

  /* ---------------------------------------------------------------- carousels */
  $$('.carr').forEach(function (c) {
    var tr = $('.hscroll', c); if (!tr) return;
    var step = function () { var f = tr.firstElementChild; return f ? f.getBoundingClientRect().width + 8 : 300; };
    $$('.arw', c).forEach(function (a) { a.addEventListener('click', function () { tr.scrollBy({ left: (a.classList.contains('l') ? -1 : 1) * step() * 2, behavior: 'smooth' }); }); });
    var dots = c.nextElementSibling && c.nextElementSibling.classList.contains('dotsrow') ? $$('span', c.nextElementSibling) : [];
    if (dots.length) tr.addEventListener('scroll', function () { var i = Math.round(tr.scrollLeft / step()); dots.forEach(function (d, k) { d.classList.toggle('on', k === Math.min(i, dots.length - 1)); }); }, { passive: true });
  });
  $$('.rwrap').forEach(function (w) {
    var tr = $('.rtrack', w), l = $('.arw.l', w), r = $('.arw.r', w);
    if (!tr) return;
    var dots = w.nextElementSibling && w.nextElementSibling.classList.contains('dotsrow') ? $$('span', w.nextElementSibling) : [];
    function card() { var f = tr.firstElementChild; return f ? f.getBoundingClientRect().width + 12 : 262; }
    function upd() {
      var max = tr.scrollWidth - tr.clientWidth - 4;
      if (l) l.disabled = tr.scrollLeft <= 4; if (r) r.disabled = tr.scrollLeft >= max;
      var i = Math.round(tr.scrollLeft / card()); dots.forEach(function (d, k) { d.classList.toggle('on', k === Math.min(i, dots.length - 1)); });
    }
    if (l) l.addEventListener('click', function () { tr.scrollBy({ left: -card() * (innerWidth > 900 ? 2 : 1), behavior: 'smooth' }); });
    if (r) r.addEventListener('click', function () { tr.scrollBy({ left: card() * (innerWidth > 900 ? 2 : 1), behavior: 'smooth' }); });
    // phones: open on the second review so a half card shows on both sides
    if (w.closest('.kr-prev') && innerWidth < 900 && tr.children.length > 2) tr.scrollLeft = card();
    tr.addEventListener('scroll', upd, { passive: true }); upd();
  });
  // one open at a time (difference cards)
  // difference cards: one open at a time on mobile; on desktop all three show side by side as equal cards
  var dsk = window.matchMedia('(min-width:900px)');
  $$('[data-one]').forEach(function (g) { $$('details', g).forEach(function (d) { d.addEventListener('toggle', function () { if (g.classList.contains('dgrid') && dsk.matches) return; if (d.open) $$('details', g).forEach(function (o) { if (o !== d) o.open = false; }); }); }); });
  $$('.dgrid').forEach(function (g) {
    if (dsk.matches) $$('details', g).forEach(function (d) { d.open = true; });
    g.addEventListener('click', function (e) { if (dsk.matches && e.target.closest('summary')) e.preventDefault(); });
  });
  // tabs
  $$('[data-tabs]').forEach(function (t) { var panes = $$(t.getAttribute('data-tabs')); $$('button', t).forEach(function (b, k) { b.addEventListener('click', function () { $$('button', t).forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); panes.forEach(function (p, j) { p.classList.toggle('on', j === k); }); }); }); });
  // segmented toggles (club: Collector / Diamond)
  $$('[data-seg-group]').forEach(function (g) { $$('button', g).forEach(function (b) { b.addEventListener('click', function () { $$('button', g).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); }); b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); $$('[data-seg-show]').forEach(function (el) { el.classList.toggle('hidden', el.getAttribute('data-seg-show') !== b.getAttribute('data-v')); }); var first = $('[data-seg-show="' + b.getAttribute('data-v') + '"] [data-plan]'); if (first) first.click(); }); }); });

  /* ---------------------------------------------------------------- customer videos (reels): load and play on tap */
  document.addEventListener('click', function (e) {
    var r = e.target.closest('.reel[data-src]'); if (!r || e.target.closest('a')) return;
    var v = $('video', r);
    if (v && e.target.closest('.rmute')) { v.muted = !v.muted; r.classList.toggle('unmuted', !v.muted); return; }
    if (!v) {
      v = document.createElement('video'); v.playsInline = true; v.setAttribute('playsinline', ''); v.controls = false; v.loop = true; v.preload = 'auto';
      v.src = r.getAttribute('data-src'); if (r.getAttribute('data-poster')) v.poster = r.getAttribute('data-poster');
      r.insertBefore(v, r.firstChild);
    }
    $$('.reel.playing video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.reel').classList.remove('playing'); } });
    if (v.paused) { v.muted = false; v.play().then(function () { r.classList.add('playing'); r.classList.add('unmuted'); }, function () { v.muted = true; v.play(); r.classList.add('playing'); r.classList.remove('unmuted'); }); }
    else { v.pause(); r.classList.remove('playing'); }
  });

  /* ---------------------------------------------------------------- hero video: poster first, video after load, pauses off screen */
  $$('[data-hv]').forEach(function (box) {
    var v = $('video', box), btn = $('.hvbtn', box); if (!v) return;
    var c = navigator.connection || {};
    if (c.saveData || /(^|-)2g/.test(c.effectiveType || '')) { if (btn) btn.hidden = true; return; }
    var held = false;
    function load() {
      if (v.getAttribute('data-l')) return; v.setAttribute('data-l', '1');
      var big = innerWidth >= 900, srcs = JSON.parse(box.getAttribute('data-hv') || '{}'), set = big ? srcs.d : srcs.m;
      (set || []).forEach(function (s) { var so = document.createElement('source'); so.src = s.src; so.type = s.type; v.appendChild(so); });
      v.load();
    }
    function state(p) { if (btn) { btn.setAttribute('data-state', p ? 'pause' : 'play'); btn.setAttribute('aria-label', p ? 'Pause video' : 'Play video'); } }
    function play() { load(); var pr = v.play(); if (pr && pr.then) pr.then(function () { state(true); box.classList.add('on'); }, function () { state(false); }); }
    if (btn) btn.addEventListener('click', function () { if (v.paused) { held = false; play(); } else { held = true; v.pause(); state(false); } });
    function go() { play(); if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (held) return; en[0].isIntersecting ? v.play().catch(function () {}) : v.pause(); }).observe(box); }
    if (document.readyState === 'complete') setTimeout(go, 150); else addEventListener('load', function () { setTimeout(go, 150); });
  });

  /* ---------------------------------------------------------------- delivery country (Shopify's own geolocation; the buyer can change it) */
  (function () {
    var c = K.country || 'your country';
    try { c = localStorage.getItem('kr-country') || c; } catch (e) {}
    function paint() { $$('[data-country]').forEach(function (el) { el.textContent = c; }); var pick = $('#country-pick'); if (pick) { $$('option', pick).forEach(function (o) { if (o.value === c) pick.value = c; }); } }
    paint();
    var s = $('#country-save'); if (s) s.addEventListener('click', function () { c = $('#country-pick').value; try { localStorage.setItem('kr-country', c); } catch (e) {} paint(); });
  })();

  /* ---------------------------------------------------------------- store reviews: 7 at a time (David, 25 Sep). Judge.me's all-reviews
     block renders 25 per page from an app setting the theme can't change. One "Load More Reviews" button: it shows the next 7,
     and once the loaded ones run out it asks Judge.me for its next page. Judge.me's own footer button stays hidden, so there is
     never a second button (David, 25 Sep). Only the list on screen is counted: Judge.me keeps the other tab's list hidden in the
     page, and counting it left the Shop Reviews tab empty after a visit to Product Reviews. A review hidden as a repeat of one of
     our hand-picked reviews (kpk-dup, sections/kr-reviews.liquid) is not counted either. */
  (function () {
    var w = $('.jmwrap'); if (!w) return;
    var STEP = 7, shown = STEP, btn;
    function native() {
      var f = $('.jdgm-all-reviews__footer, .jdgm-paginate', w); if (!f) return null;
      var b = $('button, a', f); if (!b || b.disabled) return null;
      var cs = getComputedStyle(b); return cs.display === 'none' || cs.visibility === 'hidden' ? null : b;
    }
    function listed() { return $$('.jdgm-rev', w).filter(function (r) { return !r.closest('.jdgm-carousel, .jdgm-gallery') && r.parentNode.offsetParent !== null && !r.classList.contains('kpk-dup'); }); }
    function apply() {
      var revs = listed();
      if (!revs.length) return;
      revs.forEach(function (r, i) { r.classList.toggle('kr-rhide', i >= shown); });
      $$('.jdgm-all-reviews__footer, .jdgm-paginate', w).forEach(function (f) { f.classList.add('kr-rhide'); });
      if (!btn) {
        btn = document.createElement('button'); btn.type = 'button'; btn.className = 'kr-rmore'; btn.textContent = 'Load More Reviews';
        btn.addEventListener('click', function () {
          var n = listed().length, more = native();
          if (shown >= n && more) more.click();
          shown += STEP; apply();
        });
        var last = revs[revs.length - 1].parentNode; last.parentNode.insertBefore(btn, last.nextSibling);
      }
      btn.hidden = shown >= revs.length && !native();
    }
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(apply, 60); }).observe(w, { childList: true, subtree: true });
    apply();
  })();

  /* ---------------------------------------------------------------- forms: stop double submits, show sending state */
  $$('form[data-once]').forEach(function (f) { f.addEventListener('submit', function () { var b = $('[type=submit]', f); if (b) { b.disabled = true; b.textContent = b.getAttribute('data-sending') || 'Sending...'; } }); });

  /* ---------------------------------------------------------------- misc: "open" deep links for support and QA (?open=cart|wish|menu|search) */
  (function () { var o = new URLSearchParams(location.search).get('open'); if (o && document.getElementById(o)) setTimeout(function () { K.open(o); }, 300); })();
})();
